import React from 'react';
import { Select } from 'AWS-UI-Components-React';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import { Asterisk } from './asterisk';

export class AccuracyButton extends React.Component {
  render() {
    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Asterisk required={this.props.required}/>
        <Select
          options={this.props.items}
          selectedId={this.props.selected}
          placeholder={this.props.text}
          onChange={this.props.onChange}
          data-cy={this.props['data-cy']}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/accuracy_button.jsx